import {
  Box,
  FormControlLabel,
  Typography,
  Alert,
} from '@mui/material';
import { RedButton } from '@app/ui/pages/landing-page/button/button.styles';
import { Field } from 'formik';
import { DEVICE } from '@app/styles';
import { styled, TextField } from '@mui/material';

export const TypographyBody = styled(Typography)`
  margin: 15px 0;
  font-family: Ubuntu, Roboto, Helvetica;
  line-height: 1.5;
  font-size: 17px;
  color: rgb(34, 34, 34);
  font-weight: 300;
`;

export const RequestFormInput = styled(Field)<{ error?: string }>`
  margin: 15px 0;
  font-family: Ubuntu, Roboto, Helvetica;
  line-height: 1.5;
  font-size: 18px;
  font-weight: 300;
  display: block;
  width: 100%;
  padding: 14px 20px;
  border: 2px solid ${(props) => (props.error ? '#f00' : '#CEDAEB')};
  -webkit-border-radius: 0;
  border-radius: 0;
  outline: none;
  color: #000;
  background-color: #fff;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
  box-sizing: border-box;

  ::placeholder {
    color: #cedaeb;
  }
`;

export const TextFieldFormInput = styled(TextField)<{ error?: boolean | string }>`
  .MuiInputBase-root {
    margin: 15px 0;
    font-family: Ubuntu, Roboto, Helvetica;
    line-height: 1.5;
    font-size: 18px;
    font-weight: 300;
    display: block;
    width: 100%;
    padding: 14px 20px;
    border: 2px solid ${(props) => (props.error ? '#f00' : '#CEDAEB')};
    -webkit-border-radius: 0;
    border-radius: 0;
    outline: none;
    color: #000;
    background-color: #fff;
    transition: 0.3s;
    box-sizing: border-box;

    #request-addr {
      width: 100% !important;

      ::placeholder {
        font-family: Ubuntu, Roboto, Helvetica;
        color: #cedaeb !important;
        opacity: 1 !important;

        &[disabled] {
          color: red !important;
        }
      }

      padding: 0;
    }
    #request-addr[disabled] {
      -webkit-text-fill-color: #cedaeb;
    }
    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
  }
`;

export const RequestFormInputWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media ${DEVICE.desktopOnly} {
    > * {
      &:first-of-type {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 10px;
      }
    }
  }
  @media ${DEVICE.mobileOnly} {
    flex-direction: column;
  }
`;

export const RequestFormFormControlLabel = styled(FormControlLabel)`
  width: 100%;
`;

export const SubmitButton = styled(RedButton)`
  margin: 20px 0;
  width: 100%;
`;

// export const Warning = styled.p`
// 	color: red;
// 	position: absolute;
// 	bottom: -20px;
// `
export const Column = styled(Box)`
  width: 100%;
  position: relative;
`;

export const Warning = styled(Alert)``;
